<script setup lang="ts">
import { ref } from 'vue'
import { RouterLink, useRoute } from 'vue-router'

defineProps<{
  tabs: { title: string; link: string }[]
  isAdminPanel?: { type: boolean }
}>()

const route = useRoute()
</script>

<template>
  <div class="relative flex items-center justify-between mb-6"
    :class="isAdminPanel ? 'border-b-[.3px] border-[#abbad5]' : ''">
    <div class="w-[84%]  flex items-center overflow-auto tabs-scrollbar">
      <RouterLink v-for="(tab, index) in tabs" :key="`tab-item${index}`" :to="tab.link"
        class="flex items-center gap-2 text-nowrap px-4 py-2  rounded-t-lg" :class="[
          route.path === tab.link
            ? 'bg-[#2d5396] text-white'
            : 'text-[#2d5396]   hover:text-[#2d5396]',
          isAdminPanel ? 'text-[15px]' : 'font-medium text-base border-b border-[#abbad5] '
        ]">
        {{ tab.title }}
      </RouterLink>
    </div>

    <div class="absolute lg:relative start-0 top-15 lg:top-auto lg:end-0  flex items-center justify-end gap-2 ">
      <slot name="actions" />
    </div>
  </div>
</template>

<style>
/* @media (max-width: 1024px) {
  .overflow-hidden-desktop {
    overflow-x: auto;
  }
} */

.tabs-scrollbar {
  scrollbar-width: thin;
  scrollbar-color: #abbad5 transparent;
}

.tabs-scrollbar::-webkit-scrollbar {
  width: 0;
  height: 4px;
}

.tabs-scrollbar::-webkit-scrollbar-track {
  display: none;
  background: transparent;
}

.tabs-scrollbar::-webkit-scrollbar-button,
.tabs-scrollbar::-webkit-scrollbar-button:single-button {
  display: none !important;
  width: 0 !important;
  height: 0 !important;
}

.tabs-scrollbar::-webkit-scrollbar-thumb {
  background: #abbad5;
  border-radius: 999px;
}

.tabs-scrollbar::-webkit-scrollbar-corner {
  display: none;
  background: transparent;
}
</style>
